import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/enums/user-role.enum';

/**
 * AdminGuard
 *
 * Restricts a route to admin roles (ADMIN / SUPER_ADMIN). Non-admins are
 * redirected to /dashboard. The backend is the real enforcer; this only hides UI.
 *
 * Usage: { path: 'admin/...', canActivate: [AuthGuard, AdminGuard] }
 */
@Injectable({ providedIn: 'root' })
export class AdminGuard {
  private static readonly ADMIN_ROLES: string[] = [
    UserRole.SUPER_ADMIN,
    UserRole.ADMIN,
  ];

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(): boolean | UrlTree {
    const user = this.authService.getCurrentUser();
    if (!user || !AdminGuard.ADMIN_ROLES.includes(user.role)) {
      return this.router.createUrlTree(['/dashboard']);
    }
    return true;
  }
}
